import appVersion from './app-version';
import { DEFAULT_GEO_LABEL_DESCRIPTIONS } from './_geographic-labels-descriptions';

export default {
  ...appVersion,
  appName: 'market iq',
  appConstants: {
    EDP_WRITE_ACCESS_GROUP_NAME: 'EDP Write Access',
    TRUSTED_USER_GROUP_NAME: 'Trusted User',
    PUBLISH_LISTINGS_GROUP_NAME: 'Publish Listings',
    WINDWARD_REPORTS_GROUP_NAME: 'Windward Reports',
    BULK_EDIT: 'Bulk Edit',
    GEO_LABEL_DESCRIPTION: DEFAULT_GEO_LABEL_DESCRIPTIONS,
    BUILDING_PH_IMAGE: 'assets/svg/building_placeholder.svg',
    MEDIA_ACCESS_PATHS: {
      availability: 'property.property_media_information/media_path',
      property: 'property_media_information/media_path',
      lease: 'property.property_media_information/media_path',
      sale: 'property.property_media_information/media_path',
    },
    MEDIA_PATH: {
      availability: 'property.property_media_information',
      property: 'property_media_information',
      lease: 'property.property_media_information',
      sale: 'property.property_media_information',
      brand: 'brand_media_information',
    },
    /**
     * @deprecated in favor of CBRE_API_MANAGER.GEOCODE_API_PATH
     */
    CBREMappingURL: 'https://maps.cbre.com/GC17/api/rest/Geocode/',
    /**
     * eVe token @deprecated in favor of CBRE_API_MANAGER.TOKEN_AUTH_PATH>
     */
    CBREAPIKey: 'ilXLaxCz3u', // CBRE mapping center token

    /**
     * Location Intelligence endpoints changes (MIQ-18893)
     *
     * CBRE API MANAGER INFO - It's a hub where we can find different apis that are published in api.cbre.com and we can access
     * by subscribing to them.
     * we need to exchange a token (AUTH_HOOK) to use in subscribed APIs(GEOCODE_API)
     *
     * CBRE API MANAGER hosts API's in https://api.cbre.com
     *
     * This is a substitution of CBREMappingURL effective on late June 2022
     * {@link https://confluence.cbre.com/display/DMR/Geocoder}
     */
    CBRE_API_MANAGER: {
      /**
       * Proxy Path to exchange valid Bearer token
       * */
      TOKEN_AUTH_PATH: '/cbre/apimanager/token',
      /**
       * Proxy path to perform geocode address searches
       */
      GEOCODE_API_PATH: '/cbre/apimanager/geocode/search',
      GEOCODE_CLIENT_ID: 'y8nafONZNm_VKOsGfb9sJ0D1vMQa',
    },
    MASKING_TOKEN: '*****',
    CIQ_API_MANAGER: {
      CIQ_API_PATH: '/ciq/token',
    },
  },
  edpMultimediaURI: 'adv-multimedia-np',
  s3AmazonAWS: 'https://s3.amazonaws.com/adv-multimedia-np/',

  CBREGoogleMapsClientId: 'gme-cbreptylimited',
  CBREGoogleMapsKey: 'AIzaSyBrGnDPygSf0PSMqj2fJVsi-bKBQbMZ698',
  CBREGaodeMapsKey: '61617fbc485eea5478b886f2a88e0664',
  baseLogOutURL:
    'https://login.microsoftonline.com/0159e9d0-09a0-4edf-96ba-a3deea363c28/oauth2/logout?post_logout_redirect_uri=',
  howToVideosURL: 'https://cbre.sharepoint.com/sites/intra-Research/SitePages/Market-IQ.aspx',

  // ====================================================================================================
  // ENV VARIABLES MANAGED (AUTO-GENERATED) - START
  // ====================================================================================================

  // AG-GRID
  // tslint:disable-next-line:max-line-length
  agGridEnterpriseKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-051920}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cbre_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Market_IQ}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Market_IQ}_need_to_be_licensed___{Market_IQ}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{9_February_2025}____[v3]_[01]_MTczOTA1OTIwMDAwMA==428c5c0b4c4c680a9ca61f90482d78d7',

  // alchemer survery
  surveyToken: 'NjY5MDI4LTNkYTQ2YjcyZDU4MTJkY2ZhZjEyNGQ5OGExMzBjNGRmMDIxYzkwMjgzMThkMjUwODQ3',

  // DATA DOG
  DATADOG_CLIENT_TOKEN: 'puba0ceb5dca88edfd7328ca9087e693184',

  // ====================================================================================================
  // ENV VARIABLES MANAGED (AUTO-GENERATED) - END
  // ====================================================================================================
};
